<template>
  <v-locale-provider>
    <router-view></router-view>
    <snackbar></snackbar>
  </v-locale-provider>
</template>
<script>
import { mapGetters } from 'vuex';
import Snackbar from '@/components/common/Snackbar/Snackbar.vue';
export default {
  components: {
    Snackbar
  },
  computed: {
    ...mapGetters('main', ['isLoading'])
  }
};
</script>
